module.exports = __webpack_public_path__ + "img/keypal-line.c29f9349.png";